export enum DocsContentView {
  GRID_VIEW = 'grid-view',
  TABLE_VIEW = 'table-view',
}
